/* ============================================================== insights
   window.keisTrack(feature, metric, key) counts one use of a feature for the
   KEIS app's Insights pages (Support searches, run times checked, the size
   guide...). Only daily totals are kept: nothing identifies the visitor, and
   the app takes anything personal out of search text before counting it.

   Each event counts once per page view, so reopening an answer or clicking
   back and forth does not inflate it. Events are batched and sent with
   sendBeacon when the page is left or hidden, or after a few seconds.
   Nothing is sent from the theme editor.
   ========================================================================= */
(function () {
  'use strict';
  if (window.keisTrack) return;

  var URL_ = '/apps/keis/track';
  var queue = [];
  var seen = {};
  var timer = null;
  var off = !!(window.Shopify && window.Shopify.designMode) || !navigator.sendBeacon;

  function flush() {
    clearTimeout(timer);
    timer = null;
    while (queue.length) {
      var batch = queue.splice(0, 25);
      try { navigator.sendBeacon(URL_, JSON.stringify({ e: batch })); } catch (e) { /* not counted */ }
    }
  }

  window.keisTrack = function (feature, metric, key) {
    if (off || !feature || !metric) return;
    var k = String(key == null ? '' : key).trim().slice(0, 160);
    var id = feature + '\u0001' + metric + '\u0001' + k.toLowerCase();
    if (seen[id]) return;
    seen[id] = true;
    queue.push([feature, metric, k]);
    if (queue.length >= 25) flush();
    else if (!timer) timer = setTimeout(flush, 4000);
  };

  /* keisTrack.beforeLeave(fn): fn runs just before the last send, for
     anything held back until the visitor is done (a search being typed). */
  var leaving = [];
  window.keisTrack.beforeLeave = function (fn) { leaving.push(fn); };
  function leave() {
    leaving.forEach(function (fn) { try { fn(); } catch (e) { /* ignore */ } });
    flush();
  }
  window.addEventListener('pagehide', leave);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') leave();
  });

  /* A contact form sent: counted by its topic, which is what people still
     had to ask about after the FAQs. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var topic = form.querySelector('[name="contact[Topic]"]');
    if (!topic && !form.querySelector('[name="contact[email]"]')) return;
    window.keisTrack('support', 'contact', topic ? topic.value : 'General');
  }, true);
})();
